const AVATAR_COLORS = [
  { backgroundColor: "#9d004f", color: "#ffffff" },
  { backgroundColor: "#007d89", color: "#ffffff" },
  { backgroundColor: "#34098d", color: "#ffffff" },
  { backgroundColor: "#0056ba", color: "#ffffff" },
  { backgroundColor: "#00a546", color: "#ffffff" },
  { backgroundColor: "#ef8100", color: "#ffffff" },
  { backgroundColor: "#007dac", color: "#ffffff" },
  { backgroundColor: "#9d00ff", color: "#ffffff" },
] as const;

const hashString = (value: string): number => {
  let hash = 0;

  for (let index = 0; index < value.length; index += 1) {
    hash = value.charCodeAt(index) + ((hash << 5) - hash);
  }

  return Math.abs(hash);
};

export const getInitialsFromName = (name: string): string => {
  const parts = name.trim().split(/\s+/).filter(Boolean);

  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();

  return `${parts[0][0] ?? ""}${parts[parts.length - 1][0] ?? ""}`.toUpperCase();
};

export const getAvatarColorsFromName = (
  name: string,
): (typeof AVATAR_COLORS)[number] => {
  return AVATAR_COLORS[hashString(name.toLowerCase()) % AVATAR_COLORS.length];
};
